module.exports = __webpack_public_path__ + "img/garde_a_vue.1c53049a.svg";